import api from '../client'

export const organizationApi = {
  list: async () => {
    const response = await api.get('/organizations')
    return response.data
  },
  
  get: async (slug) => {
    const response = await api.get(`/organizations/${slug}`)
    return response.data
  },
  
  updateOrganization: async (orgId, updates) => {
    const response = await api.patch(`/organizations/${orgId}`, updates)
    return response.data
  },
  
  updateOrganizationSettings: async (orgId, settings) => {
    const response = await api.patch(`/organizations/${orgId}/settings`, settings)
    return response.data
  },

  getPersonalizedBetsSettings: async (orgId) => {
    const response = await api.get(`/organizations/${orgId}/personalized-bets`)
    return response.data
  },

  updatePersonalizedBetsSettings: async (orgId, settings) => {
    const response = await api.patch(`/organizations/${orgId}/personalized-bets`, settings)
    return response.data
  },

  getWISettings: async (orgId) => {
    const response = await api.get(`/organizations/${orgId}/wi-settings`)
    return response.data
  },

  updateWISettings: async (orgId, settings) => {
    const response = await api.patch(`/organizations/${orgId}/wi-settings`, settings)
    return response.data
  },

  getSourceFeedRuntime: async (orgId) => {
    const response = await api.get(`/organizations/${orgId}/source-feed-runtime`)
    return response.data
  },

  getFeedSecurity: async (orgId) => {
    const response = await api.get(`/organizations/${orgId}/feed-security`)
    return response.data
  },

  updateFeedSecurity: async (orgId, config) => {
    const response = await api.patch(`/organizations/${orgId}/feed-security`, config)
    return response.data
  },
  
  deleteOrganization: async (orgId) => {
    await api.delete(`/organizations/${orgId}`)
  },

  getBranding: async (orgId) => {
    const response = await api.get(`/organizations/${orgId}/branding`)
    return response.data
  },

  updateBranding: async (orgId, branding) => {
    const response = await api.patch(`/organizations/${orgId}/branding`, branding)
    return response.data
  },

  // Open to every org admin, clients included. `kind` is one of
  // winning-ticket | crowd-recommendation | personalized-ticket; `tokens` is a
  // flat map of that kind's branding group values ('' or null returns a token
  // to its default). Answers { kind, tokens }.
  updateGeneratedPostBranding: async (orgId, kind, tokens) => {
    const response = await api.patch(`/organizations/${orgId}/branding/generated-posts/${encodeURIComponent(kind)}`, tokens)
    return response.data
  },

  uploadBannerImage: async (orgId, file) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post(`/organizations/${orgId}/branding/banner-image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  }
}

export const productApi = {
  list: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/products`)
    return response.data
  },
}
